import { AuthConfig } from "angular-oauth2-oidc";
import { environment } from "environments/environment";

// Admin api scope is required for department admins
const scope =
  "celo_api openid offline_access celo_integration_api celo_admin_api";

export const authCodeFlowConfig: AuthConfig = {
  // Url of the Identity Provider
  issuer: environment.celoAuthApiEndpoint + "/",
  redirectUri: environment.origin + "/signin-oidc",
  postLogoutRedirectUri: environment.origin + "/signout-callback-oidc",
  clientId: environment.clientId,
  responseType: "code",
  scope,
  showDebugInformation: !environment.production,
  strictDiscoveryDocumentValidation: false,
  requireHttps: false,
  fallbackAccessTokenExpirationTimeInSec: 300,

  // Without this the library defaults to ten minutes, which makes
  // hasValidAccessToken() report an access token as valid for ten minutes
  // after it expired. Everything that asks "are we signed in?" — the auth
  // guard, app initialization, the focus-regain recovery — would then skip the
  // refresh it should perform and rely on a request failing with a 401 first.
  //
  // This is not set to 0 because the same value also tolerates clock drift
  // when validating the id_token's iat and exp claims, and a client whose
  // clock is behind the server would fail to sign in at all. Thirty seconds is
  // enough for realistic drift and small enough that the proactive refresh at
  // 75% of the token's lifetime still runs well before expiry.
  //
  // Note: do not reach for decreaseExpirationBySec to add a safety margin. The
  // library subtracts it from a millisecond value despite the name, so it does
  // not mean seconds.
  clockSkewInSec: 30,
};
